import type { ComputedRef } from 'vue'

import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

import type { TenantModel } from '@/domains/tenant/types/TenantModel.types'

/**
 * The single access point for the tenant-level EXO truth (spec §3/§4). Reads the
 * `tenant.is_exo` shared Inertia prop and returns false when the prop is absent —
 * landlord-context pages carry no tenant, which is correctly never EXO. Every badge,
 * lock and readiness consumer imports this; none read `usePage().props.tenant` directly.
 * The prop is cast because Inertia's `usePage()` doesn't resolve the global PageProps
 * augmentation here (same pattern as usePlanGate).
 */
const useTenantIsExo = (): ComputedRef<boolean> => {
  const page = usePage()
  return computed(() => (page.props.tenant as TenantModel | undefined)?.is_exo ?? false)
}

export { useTenantIsExo }
